import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData, putData, getData } from "../../../../services/apiEndpoints";

// Create a new visitor (Pre-registered or Direct)
export const createVisitorThunk = createAsyncThunk(
  "visitor/create",
  async (payload, { rejectWithValue }) => {
    try {
      // Endpoint is assumed to be '/visitors' based on the domain logic
      const response = await postData("/admin/add/visitors", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to add visitor" });
    }
  }
);

// Fetch a paginated and filtered list of visitors
export const fetchVisitorsThunk = createAsyncThunk(
  "visitor/fetchAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await getData(`/admin/all/visitors?${query}`);
      return response;

    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch visitors" });
    }
  }
);

// Update a visitor (e.g., check-out, status change)
export const updateVisitorThunk = createAsyncThunk(
  "visitor/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await putData(`/admin/update/visitors/${id}`, data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to update visitor" });
    }
  }
);

